import { Component, input } from "@angular/core";
import type { Corpus } from "@pienso/ingest-types/corpus.interface";
import type { Page } from "./grid-data.provider";
import type { HeaderRendererColumn } from "./header-renderer.interface";

@Component({ template: `<div class="datatable-header-cell-wrapper"></div>` })
export class DefaultRowNumberHeaderRendererComponent {
  readonly column = input.required<HeaderRendererColumn>();
  readonly corpus = input.required<Corpus>();
  readonly editable = input.required<boolean>();
  readonly page = input<Page>();
}
